<template>
    <v-dialog v-if="show" v-model="show"  transition="dialog-bottom-transition" fullscreen>
        <v-card fill-height class="d-flex flex-column">
            <v-app-bar app dark dense color="primary">
                <v-btn icon dark @click="closeDialog">
                    <v-icon>mdi-close</v-icon>
                </v-btn>
                <v-toolbar-title>Job Description</v-toolbar-title>
                <v-spacer></v-spacer>
            </v-app-bar>
      
            <v-container dense class="px-5 py-15 flex-grow-1">
                <v-row class="space-between pt-15 h-100">
                    <v-col cols="3">
                    
                        <!---------- TAB BAR ----------->
                    
                        <v-tabs vertical v-model="tab" :slider-size=5 >
                            <v-tab v-for="tab in tabs" :key="tab">{{ tab }}</v-tab>
                        </v-tabs>
                    
                        <!---------- TAB BAR ----------->
                    
                    </v-col>
                    
                    <v-col cols="9">

                        <!---------- TAB CONTENT ----------->
                    
                        <v-tabs-items v-model="tab" class="pa-3">

                        <!---------- CUSTOMER DETAILS CONTENT ----------->
                        
                            <v-tab-item>
                                <v-row justify="space-between">
                                    <v-col cols="6" class="p-10">
                                        <label class="overline ma-0">
                                            Customer Name:
                                        </label>
                                        <v-text-field
                                            :value="jobInfo.customer.fname +' '+ jobInfo.customer.lname"    
                                            solo
                                            readonly
                                        >
                                        </v-text-field>
                                    </v-col>
                                    <v-col cols="6" class="p-10">
                                        <label class="overline ma-0">
                                            Phone:
                                        </label>
                                        <v-text-field
                                            :value="jobInfo.customer.phone"    
                                            solo
                                            readonly
                                        >
                                        </v-text-field>
                                    </v-col>
                                    <v-col cols="6" class="p-10">
                                        <label class="overline ma-0">
                                            Email:
                                        </label>
                                        <v-text-field
                                            :value="jobInfo.customer.email"    
                                            solo
                                            readonly
                                        >
                                        </v-text-field>
                                    </v-col>
                                </v-row>
                            </v-tab-item>

                        <!---------- CUSTOMER DETAILS CONTENT ----------->

                        <!---------- JOB DETAILS CONTENT ----------->

                            <v-tab-item>
                                <v-row justify="space-between">
                                    <v-col cols="6" class="p-10">
                                        <label class="overline ma-0">
                                            Job ID:
                                        </label>
                                        <v-text-field
                                            :value="jobInfo.jobID"    
                                            solo
                                            readonly
                                        >
                                        </v-text-field>
                                    </v-col>
                                    <v-col cols="6" class="p-10">
                                        <label class="overline ma-0">
                                            Status:
                                        </label>
                                        <v-text-field
                                            :value="jobInfo.status"    
                                            solo
                                            readonly
                                        >
                                        </v-text-field>
                                    </v-col>
                                    <v-col 
                                        cols="6" 
                                        class="p-10" 
                                        v-for="(type, index) in jobInfo.jobTypes"  
                                        :key="index"
                                    >
                                        <label class="overline ma-0">
                                            Job Type:
                                        </label>
                                        <v-text-field
                                            :value="type.jobType"    
                                            solo
                                            readonly
                                        >
                                        </v-text-field>
                                    </v-col>
                                    <v-col cols="6" class="p-10">
                                        <small class="text-primary">Selected Vehicle:</small>
                                        <div>
                                            <v-chip class="ma-1" color="primary" text-color="white">
                                                Make: {{jobInfo.vehicle.key.make}}
                                            </v-chip>
                                            <v-chip class="ma-1" color="primary" text-color="white">
                                                Model: {{jobInfo.vehicle.key.model}}
                                            </v-chip>
                                            <v-chip class="ma-1" color="primary" text-color="white">
                                                Year: {{jobInfo.vehicle.key.year}}
                                            </v-chip>
                                        </div>
                                    </v-col>
                                    <v-col cols="6" v-for="(type, index) in jobInfo.jobTypes" :key="index" v-if="type.item && type.item.item"> 
                                        <small class="text-info">Selected Key:</small>
                                        <div>
                                            <v-avatar left>
                                                <v-img v-bind:src="type.item.item.key.image"></v-img>
                                            </v-avatar>
                                            <v-chip class="ma-1" color="green" text-color="white">
                                                OEM: {{type.item.item.key.oem}}
                                            </v-chip>
                                            <v-chip class="ma-1" color="green" text-color="white">
                                                FCC: {{type.item.item.key.fcc}}
                                            </v-chip>
                                            <v-chip class="ma-1" color="green" text-color="white">
                                                IC: {{type.item.item.key.ic}}
                                            </v-chip>
                                        </div>
                                    </v-col>

                                </v-row>
                            </v-tab-item>

                        <!---------- JOB DETAILS CONTENT ----------->

                        <!---------- VEHICLE DETAILS CONTENT ----------->
                        
                            <v-tab-item>
                                <v-row justify="space-between">
                                    <v-col 
                                        cols="6" 
                                        class="p-10"
                                        v-for="(type, index) in jobInfo.jobTypes" 
                                        :key="index"    
                                    >
                                        <label class="overline ma-0">
                                            Quote:
                                        </label>
                                        <v-text-field
                                            :value="'$' + type.quote"    
                                            solo
                                            readonly
                                        >
                                        </v-text-field>
                                    </v-col>
                                    <v-col cols="6" class="p-10">
                                        <label class="overline ma-0">
                                            VIN Number:
                                        </label>
                                        <v-text-field
                                            :value="jobInfo.vin_num"    
                                            solo
                                            readonly
                                        >
                                        </v-text-field>
                                    </v-col>
                                    <v-col cols="6" class="p-10">
                                        <label class="overline ma-0">
                                            Colour:
                                        </label>
                                        <v-text-field
                                            :value="jobInfo.colour"    
                                            solo
                                            readonly
                                        >
                                        </v-text-field>
                                    </v-col>
                                    <v-col cols="6" class="p-10">
                                        <label class="overline ma-0">
                                            Lisence Plate:
                                        </label>
                                        <v-text-field
                                            :value="jobInfo.lisence"    
                                            solo
                                            readonly
                                        >
                                        </v-text-field>
                                    </v-col>
                                    <v-col cols="6" class="p-10">
                                        <label class="overline ma-0">
                                            CAA:
                                        </label>
                                        <v-text-field
                                            :value="jobInfo.caa"    
                                            solo
                                            readonly
                                        >
                                        </v-text-field>
                                    </v-col>
                                </v-row>
                            </v-tab-item>

                        <!---------- VEHICLE DETAILS CONTENT ----------->

                        <!---------- TIME DETAILS CONTENT ----------->
                        
                            <v-tab-item>
                                <v-row justify="space-between">
                                    <v-col cols="6" class="p-10">
                                        <label class="overline ma-0">
                                            Technician:
                                        </label>
                                        <v-text-field
                                            :value="jobInfo.user.username"    
                                            solo
                                            readonly
                                        >
                                        </v-text-field>
                                    </v-col>
                                    <v-col cols="6" class="p-10">
                                        <label class="overline ma-0">
                                            Schedule Date:
                                        </label>
                                        <v-text-field
                                            :value="getDate"    
                                            solo
                                            readonly
                                        >
                                        </v-text-field>
                                    </v-col>
                                    <v-col cols="6" class="p-10">
                                        <v-row>
                                            <v-col cols="6">
                                                <label class="overline ma-0">
                                                    Start:
                                                </label>
                                                <v-text-field
                                                    :value="getStart"    
                                                    solo
                                                    readonly
                                                >
                                                </v-text-field>
                                            </v-col>
                                            <v-col cols="6">
                                                <label class="overline ma-0">
                                                    End:
                                                </label>
                                                <v-text-field
                                                    :value="getEnd"    
                                                    solo
                                                    readonly
                                                >
                                                </v-text-field>
                                            </v-col>
                                        </v-row>
                                    </v-col>
                                    <v-col cols="6" class="p-10">
                                        <label class="overline ma-0">
                                            Address:
                                        </label>
                                        <v-text-field
                                            :value="jobInfo.address"    
                                            solo
                                            readonly
                                        >
                                        </v-text-field>
                                    </v-col>
                                    <v-col cols="6" class="p-10">
                                        <label class="overline ma-0">
                                            Remarks:
                                        </label>
                                        <v-text-field
                                            :value="jobInfo.opRemarks"    
                                            solo
                                            readonly
                                        >
                                        </v-text-field>
                                    </v-col>
                                </v-row>
                            </v-tab-item>
                        
                        <!---------- TIME DETAILS CONTENT ----------->

                        <!---------- JOB HISTORY DETAILS CONTENT ----------->

                            <v-tab-item>
                                <v-row justify="space-between">
                                    <v-col cols="6" class="p-10">
                                        <div
                                            v-for="(jobhistarray, index) in filteredJobHistorys"
                                            :key="index"
                                            class="stepper_item"
                                            :class="{ active: filteredJobHistorys.length === index + 1 }"
                                        >
                                            <div class="stepper_steps">
                                                <span class="stepper_step_circle">
                                                {{ index + 1 }}
                                                </span>
                                                <div
                                                class="stepper_step_line"
                                                v-if="filteredJobHistorys.length !== index + 1"
                                                ></div>
                                            </div>
                                            <div>
                                                <h6 class="job_title">
                                                {{ jobhistarray.status }}
                                                </h6>
                                                <div>
                                                <p class="job_desc">
                                                    {{ jobhistarray.type }} |
                                                    {{ formatDate(jobhistarray.createDate) }}
                                                </p>
                                                </div>
                                            </div>
                                        </div>
                                    </v-col>
                                </v-row>
                            </v-tab-item>                

                        <!---------- JOB HISTORY  CONTENT ----------->

                        </v-tabs-items>

                        <!---------- TAB CONTENT ----------->
                    
                    </v-col>
                
                </v-row>

                <div v-if="jobInfo.status == 'COMPLETED'">
                    <v-row justify="space-between">
                        <v-col cols="2" class="text-primary p-10">
                            <h6 class="main_label text-primary">
                                Completition Details:
                            </h6>
                        </v-col>
                        <v-col cols="4" class="p-10">
                            <v-text-field v-model="jobInfo.method" dense filled readonly color="purple darken-2" label="Payment Method:" />
                        </v-col>
                        <v-col cols="1"></v-col>
                        <v-col cols="4">
                            <v-text-field 
                                v-for="(type, index) in jobInfo.jobTypes" 
                                :key="index"
                                :value="'$' + type.actual_price" dense filled readonly color="purple darken-2" label="Price:" />
                        </v-col>
                    </v-row>
                    <v-row v-if="jobInfo.caaCard" style="height: 65px;">
                        <v-col cols="2"></v-col>
                        <v-col cols="4">
                            <v-text-field v-model="jobInfo.caaCard.name" dense filled readonly color="purple darken-2" label="CAA Name:" />
                        </v-col>
                        <v-col cols="1"></v-col>
                        <v-col cols="2">
                            <v-text-field v-model="jobInfo.caaCard.number" dense filled readonly color="purple darken-2" label="CAA Number:" />
                        </v-col>
                        <v-col cols="2">
                            <v-text-field v-model="jobInfo.caaCard.type" dense filled readonly color="purple darken-2" label="CAA Type:" />
                        </v-col>
                    </v-row>
                    <v-row  justify="space-between">
                        <v-col cols="2"></v-col>
                        <v-col cols="4">
                            <v-text-field v-model="jobInfo.vin" dense filled readonly color="purple darken-2" label="VIN:" />
                        </v-col>
                        <v-col cols="1">
                        </v-col>
                        <v-col cols="4">
                            <v-text-field v-model="jobInfo.used" dense filled readonly color="purple darken-2" label="Keys Used:" />
                        </v-col>
                    </v-row>

                    <v-row justify="space-between">
                        <v-col cols="2"></v-col>
                        <v-col cols="4">
                            <v-text-field v-model="jobInfo.techRemarks" dense filled readonly color="purple darken-2" label="Remarks:" />
                        </v-col>
                    </v-row>

                    <v-divider></v-divider>
                </div>
        
                <div>
                    <v-row justify="space-between">
                      
                        
                        <v-col cols="4" class="p-4">
                        </v-col>
                    </v-row>
                </div>
            </v-container>
        </v-card>
    </v-dialog>
</template>

<script>
import { DateTime } from 'luxon'
    
export default {
    name: 'JobDialog',
    props: ['jobInfo', 'show'],
    data() {
        return {
            filteredJobHistorys: null,
            tab: null,
            tabs: [
                'Customer Details', 'Job Details', 'Vehicle Details', 'Time Details', 'Job History Details'
            ],
        }
    },
    mounted() {
        this.getJobHistory(this.$props.jobInfo.id)
    },
    computed: {
        getDate: function () {
            return this.getReadableDate(this.$props.jobInfo.date);
        },
        getStart: function () {
            return this.getReadableTime(this.jobInfo.from);
        },
        getEnd: function () {
            return this.getReadableTime(this.jobInfo.to);
        },
    },
    methods: {
        getReadableDate(date) {
            var options = {
                year: 'numeric',
                month: 'numeric',
                day: 'numeric'
            }
            return new Date(date).toLocaleDateString('en-US', options)
        },
        formatDate(date) {
            const formattedDate = DateTime.fromMillis(date).toFormat("dd yyyy LLL");
            return formattedDate;
        },
        getJobHistory(id) {
                this.$api
                .getHistoryOfJob(id)
                .then(res => {
                    if (res.status == 200) {
                        const jobHistorys = res.data
                        this.filteredJobHistorys = jobHistorys.sort((a, b) => a.createDate - b.createDate);
                    }
                })
        },
        closeDialog() {
            this.$emit('close')
        },
        getReadableTime(date) {
            let d = new Date(date).toUTCString()
            let hours = d.substring(17, 19);
            let minutes = d.substring(20, 22)
            return this.formatAMPM(hours, minutes)
        },
        formatAMPM(hours, minutes) {
            var ampm = hours >= 12 ? 'PM' : 'AM'
            hours = hours % 12
            hours = hours ? hours : 12
            var strTime = hours + ':' + minutes + ' ' + ampm
            return strTime
        },
    }
}
</script>

<style>
.main_label {
    line-height: 2rem;
    font-weight: 600;
    margin: 0;
}
.stepper_steps {
  display: flex;
  flex-direction: column;
  align-items: center;
}
.stepper_item {
  display: flex;
  gap: 35px;
}
.stepper_step_circle {
  width: 32px;
  height: 32px;
  min-width: 32px;
  display: grid;
  place-items: center;
  font-size: 15px;
  border-radius: 50%;
  background: rgba(0, 0, 0, 0.35);
  color: #fff;
}
.stepper_item.active .stepper_step_circle {
  background: #007bff;
}
.stepper_step_line {
  width: 1px;
  min-height: 40px;
  background: rgba(0, 0, 0, 0.35);
  margin: 5px;
}
.job_title {
  color: rgba(0, 0, 0, 0.35);
  font-size: 18px;
  line-height: 1;
  margin-bottom: 5px;
}
.job_desc {
  color: rgba(0, 0, 0, 0.35);
  font-size: 14px;
  line-height: 1;
  margin: 0 !important;
}
.stepper_item.active .job_title,
.stepper_item.active .job_desc {
  color: #007bff;
}
.v-slide-group__content {
    gap: 15px;
    align-items: flex-start;
}

.v-tab {
    width: 100%;
    justify-content: flex-start !important;
    padding-left: 30px !important;
    text-transform: capitalize !important;
}
</style>